import { api } from '../api/api';
import { Documentation, DocumentationCreate, DocumentationItemCreate } from '../types/documentation';

export const documentationApi = {
    async getProjectDocumentation(projectId: number) {
        const response = await api.get<Documentation[]>(`/api/v1/projects/${projectId}/documentation`);
        return response;
    },

    async getDocumentation(id: number) {
        const response = await api.get<Documentation>(`/api/v1/documentation/${id}`);
        return response;
    },

    async createDocumentation(projectId: number, data: DocumentationCreate) {
        const response = await api.post<Documentation>(`/api/v1/projects/${projectId}/documentation`, data);
        return response;
    },

    async updateDocumentation(id: number, data: Partial<DocumentationCreate>) {
        const response = await api.put<Documentation>(`/api/v1/documentation/${id}`, data);
        return response;
    },

    async deleteDocumentation(id: number) {
        const response = await api.delete(`/api/v1/documentation/${id}`);
        return response;
    },

    async createDocumentationItem(documentationId: number, data: DocumentationItemCreate) {
        const response = await api.post(`/api/v1/documentation/${documentationId}/items`, data);
        return response;
    },

    async updateDocumentationItem(documentationId: number, itemId: number, data: Partial<DocumentationItemCreate>) {
        const response = await api.put(`/api/v1/documentation/items/${itemId}`, data);
        return response;
    },

    async deleteDocumentationItem(documentationId: number, itemId: number) {
        const response = await api.delete(`/api/v1/documentation/items/${itemId}`);
        return response;
    },

    async uploadFile(documentationId: number, file: File, description?: string, title?: string) {
        const formData = new FormData();
        formData.append('file', file);
        if (description) {
            formData.append('description', description);
        }
        if (title) {
            formData.append('title', title);
        }
        const response = await api.post(`/api/v1/documentation/${documentationId}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response;
    },
}; 